import product1 from "../assets/product-1.jpeg"
import product2 from "../assets/product-2.jpeg"
import product3 from "../assets/product-3.jpeg"
import product4 from "../assets/product-4.jpeg"
import product5 from "../assets/product-5.jpeg"
import product6 from "../assets/product-6.jpg"
import product7 from "../assets/product-7.jpeg"
import product8 from "../assets/product-8.jpg"


const ProjectCardData = [
    {
        imgsrc: product2, 
        title: "Gum Damar",
        text: "Gum Damar is the result of secretions (pus or sap) of the trees Shorea sp., Vatica, sp., Dryobalanops sp., and other plants of the order meranti-merantian or Dipterocarpaceae. Plastic resin can be used as raw material for matches, resin, plaster, varnish, paint, ink industry stabilizer and cosmetics. Besides being an industrial raw material, damar gum can be burned as a lighting tool and can also be used as a batik material."
    ,   button: "More details",
        url: "/product/dammar-gum"
    },
    {
        imgsrc: product7, 
        title: "Gum Benzoin",
        text: "Gum Benzoin is a balsamic resin obtained from the bark of several species of trees of the genus Styrax. Benzoin is sometimes called Gum Benzoin or Gum Benjamin. Gum Benzoin is commonly used in perfumes and some fragrances and as a flavoring in alcoholic and non-alcoholic beverages, baked goods, chewing gum, frozen dairy products, gelatin, puddings, soft candies, and even medicine."
        , button: "More details",
        url: "/product/dammar-gum"
    },
    {
        imgsrc: product5, 
        title: "Damar Batu",
        text: "Damar Batu is the fossilized resin obtained from the botanical order Dipterocarpaceae. Due to the natural curing process, the resin is slightly yellow in color, but some are white to golden brown. In industrial, Damar batu is commonly used as a raw material for paints, batik dyes, waxes, printing inks, linoleum and cosmetics."
        ,   button: "More details",
        url: "/product/dammar-batu"
    },
    {
        imgsrc: product4, 
        title: "Gum Rosin",
        text: "Gum Rosin is a natural product of Indonesia that comes from the distillation of pine and some other trees, mainly conifers. Gum rosin are used industrially as raw materials for paper, inks, explosives, adhesives, soaps and others. Gum rosin can be used as a polishing agent in pills (medicine) and chewing gum."
    },
    {
        imgsrc: product6, 
        title: "Tapioca Flour",
        text: "Tapioca Flour is made by crushing and drying the fibrous tapioca root. Many traditional dishes and drinks use tapioca as the main ingredient, such as crackers, pempeks, tekwan, meatballs, dumplings, pacar cina and kolak biji salak. Tapioca is also used as a mixture in cakes, such as pepe (a type of layered cake), moci and other cakes. Tapioca is primarily a carbohydrate, with low levels of protein, saturated fat, and sodium. The content of vitamins and minerals in it is negligible.",
    },
    {
        imgsrc: product1, 
        title: "Turpentine Oil",
        text: "Turpentine Oil is a liquid obtained by distilling resin obtained from living trees, mainly pine trees. Mainly used as a specialized solvent, it is also a source of raw materials for organic synthesis. In foods and beverages, distilled turpentine oil is used as a flavoring. In manufacturing, turpentine oil is used in soaps and cosmetics, and as a paint solvent. It is also added to perfumes, foods and detergents as a fragrance."
    },
    {
        imgsrc: product8, 
        title: "Wood Pellet",
        text: "Wood Pellet are a solid fuel made from compressed organic material. This type of fuel is often used to replace coal because wood pellet are flammable and have a pretty good flame and is more environmentally friendly because wood pellet production can also increase the use of wood waste, reduce deforestation, and help reduce carbon dioxide emissions. In addition, wood pellet can also be used as fuel in stoves. Furthermore, wood pellets dan also be used to replace fossil fuels in power plants."
    },
    {
        imgsrc: product3, 
        title: "Gum Copal",
        text: "Gum Copal is a resin produced from the resin of forest trees of the genus Daniellia. Due to common impurities and regional differences, the color of copal resin varies from black to yellow to white. Nowadays copal gum is commonly used as incense. Our company offers PWS grade with lighter color and texture range 5 to 7 cm. In addition, our company offers a WS grade that is slightly darker in color and has a similar structure to the PWS grade."
    }
]



export default ProjectCardData;







